<script setup lang="ts">
import { RouterView } from 'vue-router'
import { locale } from './core/locale/locale'
import { useAppDebug } from './debug/useAppDebug'
import BackgroundMusic from './components/audio/BackgroundMusic.vue'

useAppDebug()
</script>

<template>
  <BackgroundMusic />
  <RouterView v-slot="{ Component }">
    <transition name="fade-view" mode="out-in">
      <component ref="view" :is="Component" :key="locale" />
    </transition>
  </RouterView>
</template>

<style scoped>
.fade-view-enter-active,
.fade-view-leave-active {
  transition: opacity 0.3s ease;
}
.fade-view-enter-from,
.fade-view-leave-to {
  opacity: 0;
}
</style>
